var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-container" },
    [
      _c(
        "div",
        { staticClass: "hx-breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { "separator-class": "el-icon-arrow-right" } },
            [
              _c("el-breadcrumb-item", [_vm._v("首页")]),
              _c("el-breadcrumb-item", [_vm._v("供应系统")]),
              _c("el-breadcrumb-item", [_vm._v("基地管理")]),
              _c("el-breadcrumb-item", [_vm._v("基地列表")]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "hx-form-container box-shadow" },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.listParams, "label-width": "100px" } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "基地名称：" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                clearable: "",
                                size: "small",
                                placeholder: "请选择基地",
                              },
                              model: {
                                value: _vm.listParams.farmId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listParams, "farmId", $$v)
                                },
                                expression: "listParams.farmId",
                              },
                            },
                            _vm._l(_vm.baseNameList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.title, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.loadTableData },
                            },
                            [_vm._v(" 查询 ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "hx-table-result",
        {
          attrs: { "page-info": _vm.pager, loading: _vm.tableLoading },
          on: {
            "page-current-change": _vm.handleCurrentChange,
            "page-size-change": _vm.handleSizeChange,
          },
        },
        [
          _c("div", { attrs: { slot: "action" }, slot: "action" }),
          _c("hx-table-result-col", [
            _c(
              "div",
              { staticClass: "wrap-table-info-display" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "align-left",
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.toCreate },
                  },
                  [_vm._v(" 新增 ")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "align-left",
                    attrs: { type: "success", size: "small" },
                    on: { click: _vm.maintainData },
                  },
                  [_vm._v(" 生产数据维护 ")]
                ),
                _c("span", { staticClass: "table-info-display" }, [
                  _c("span", [_vm._v("总条数：")]),
                  _c("span", { staticClass: "alert-text ft16" }, [
                    _vm._v(_vm._s(_vm.pager.total)),
                  ]),
                ]),
              ],
              1
            ),
          ]),
          _c(
            "el-table",
            {
              attrs: { slot: "content", data: _vm.tableData, border: "" },
              slot: "content",
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", width: "60", label: "序号" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(
                              (_vm.pager.pageIndex > 1
                                ? (_vm.pager.pageIndex - 1) * _vm.pager.pageSize
                                : 0) +
                                scope.$index +
                                1
                            ),
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "title", align: "center", label: "基地名称" },
              }),
              _c("el-table-column", {
                attrs: { prop: "address", align: "center", label: "基地地址" },
              }),
              _c("el-table-column", {
                attrs: { prop: "sort", align: "center", label: "排序" },
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.editItem(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _c(
                          "confirm-button",
                          {
                            staticStyle: { margin: "0 10px" },
                            attrs: {
                              type: "text",
                              title: "确认要删除该条数据？",
                            },
                            on: {
                              confirmed: function ($event) {
                                return _vm.deleteItem(scope.row.farmId)
                              },
                            },
                          },
                          [_c("span", [_vm._v("删除")])]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "hx-to-create-template",
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            width: "40%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.resetDialogForm,
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "dialogForm",
                  attrs: {
                    model: _vm.itemParams,
                    rules: _vm.checkItemParams,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "基地名称 ：", prop: "title" } },
                    [
                      _c("el-input", {
                        attrs: { size: "small", placeholder: "请输入基地名称" },
                        model: {
                          value: _vm.itemParams.title,
                          callback: function ($$v) {
                            _vm.$set(_vm.itemParams, "title", $$v)
                          },
                          expression: "itemParams.title",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "基地地址 ：", prop: "address" } },
                    [
                      _c("el-input", {
                        attrs: { size: "small", placeholder: "请输入基地地址" },
                        model: {
                          value: _vm.itemParams.address,
                          callback: function ($$v) {
                            _vm.$set(_vm.itemParams, "address", $$v)
                          },
                          expression: "itemParams.address",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "序号：", prop: "sort" } },
                    [
                      _c("el-input-number", {
                        attrs: { size: "small", min: 1, label: "描述文字" },
                        model: {
                          value: _vm.itemParams.sort,
                          callback: function ($$v) {
                            _vm.$set(_vm.itemParams, "sort", $$v)
                          },
                          expression: "itemParams.sort",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            size: "small",
                            type: "primary",
                            disabled: _vm.isDisabled,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.saveItem("dialogForm")
                            },
                          },
                        },
                        [_vm._v(" 保 存 ")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: {
                            click: function ($event) {
                              _vm.dialogVisible = false
                            },
                          },
                        },
                        [_vm._v(" 取 消 ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }